<template>
  <div class="download">
    <img class="app-main" src="../../assets/bg2.jpg" alt="">
    <div class="app-footer">
      <!-- <div class="footer-logo">
         <img src="../../assets/logo.svg" alt="">
      </div> -->
      <div class="footer-content">
        <div class="footer-title">
          <img src="../../assets/title2.png" alt="">
        </div>
        <div class="app-down">
          <button class="down-action" @click="handleH5Download">下载舌尖英雄APP</button>
        </div>
      </div>
      <img class="footer-bg" src="../../assets/bg3.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Download',
  mounted(){
    document.title =  "舌尖英雄"
    // window.location.href = 'https://apps.apple.com/cn/app/id1601762058'
  },
  methods:{
    handleH5Download(event){
      console.log('click')
      // window.location.href = 'https://apps.apple.com/cn/app/id1601762058'
    }
  }
}
</script>

<style lang="scss" scoped>
.download{
  height: 100%;
  .app-main{
    width: 100%;
  }
  .app-footer{
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    .footer-bg{
      width: 100%;
    }
    .footer-content{
      /* margin-top: -110px; */
      position: absolute;
      left: 0;
      right: 0;
      top: 100px;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .footer-title{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px 40px 70px 0;
        img{
          width: 400px;
        }
      }
      .app-down{
        margin-bottom: 24px;
        .down-action{
          background: #FF6A39; 
          width: 562px;
          height: 96px;
          border-radius: 48px;
          font-size: 32px;
          font-weight: 500;
          color: white;
          line-height: 94px;
          text-align: center;
          border: none;
          outline: none;
        }
      }
    }
  }
}
</style>
